import { StyledLabel } from './styled';
/**
 * Form label. To be used with form elements.
 */
export function Label(props) {
    return <StyledLabel {...props}/>;
}
